import { Component, OnInit, ViewChild, TemplateRef, AfterViewInit, ViewChildren, QueryList, AfterContentInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AggregationDetailComponent } from '../aggregation-detail/aggregation-detail.component';
import { TitleService } from 'src/app/shared/services/title.service';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { forkJoin } from 'rxjs';
import { ClientBillingIgnoreProductService, AggregationResultService, SFClientRegistryService } from 'src/app/shared/api/services';
import { ClientBillingAggregationResult, Party } from 'src/app/shared/api/models';
import { AggregationResultStatus } from 'src/app/shared/enums/AggregationResultStatus';
import { matchClientPartyRow } from '../../shared/classes/helpers';
import { TableColumn, SelectionType } from '@swimlane/ngx-datatable';
import { ErrorHandlerComponent } from 'src/app/shared/components/error-handler/error-handler.component';
import { PermissionsService } from '../../shared/services/permissions.service';
import { Persona } from 'src/app/shared/enums/Persona';
import { NgSelectComponent } from '@ng-select/ng-select';

@Component({
  selector: 'e2cb-aggregation',
  templateUrl: './aggregation.component.html',
  styleUrls: ['./aggregation.component.scss']
})
export class AggregationComponent implements OnInit, AfterViewInit, AfterContentInit {
  @ViewChild(AggregationDetailComponent, {static: true}) _aggregationDetailComponent;
  @ViewChild('content', {static: true}) content: TemplateRef<any>;
  @ViewChild(ErrorHandlerComponent, {static: true}) errorHandlerComponent: ErrorHandlerComponent;
  @ViewChildren('mySelect') mySelect: QueryList<NgSelectComponent>;
  @ViewChildren('newAndOthersAggregationsGrid') myDataTable: QueryList<NgSelectComponent>;

  // #region Public Variables
  public aggrDetailLoading: boolean = false;
  public showSpinner: boolean = false;
  public newRows: any[] = [];
  public otherRows: any[] = [];
  public incompleteExtractRows: any[] = [];
  public selecteDropdownClient = "" ;

  public newAggregationsVisible: boolean = true;
  public otherAggregationsVisible: boolean = true;
  public tab_NewOrOthers = 'new';
  public matchClientPartyRow = matchClientPartyRow;
  public hasTouchedGrid = false;
  public selectedNew = [];
  public selectedOther = [];
  public selectedClient: Party = null;
  public SelectionType = SelectionType;
  public curSelectionType = SelectionType.single;
  public hasPermissionToEdit = false;
  // #endregion

  //#region Private variables
  private interval: any;
  //#endregion

  // #region ReadOnly Variables
  readonly columns: TableColumn[] = [
    {
      width: 30,
      sortable: false,
      canAutoResize: false,
      draggable: false,
      resizeable: false,
      headerCheckboxable: true,
      checkboxable: true,
      cellClass: 'checkbox-cells'
    },
    { name: 'Client ID', prop: 'clientId' },
    { name: 'Exception Count', prop: 'exceptionCount' },
    { name: 'Aggregation Count', prop: 'aggregationCount' },
    { name: 'State', prop: 'status' }
  ];
  readonly rowHeight: number = 50;
  // #endregion

  // #region Constructors
  constructor(
              private _titleService: TitleService,
              public sharedDataService: SharedDataService,
              private _modalService: NgbModal,
              public clientBillingIgnoreProductService: ClientBillingIgnoreProductService,
              public sfClientRegistryBL: SFClientRegistryService,
              private aggregationResultService: AggregationResultService,
              public permissionsSerivce: PermissionsService) {
    this._titleService.Subtitle = 'Usage Aggregation';
  }
  ngAfterContentInit(): void {}

  ngAfterViewInit(): void {}
  // #endregion

  // #region Public Methods
  async ngOnInit(force: boolean = false) {
    this.hasPermissionToEdit = this.permissionsSerivce.hasAtLeastOnePersona([
      Persona.ClientBillingSuperUser,
      Persona.ClientBillingManager
    ]);
    // show spinner.
    this.showSpinner = true;
    // load data
    await forkJoin([
      this.sharedDataService.PopulateIgnoreProducts(force),
      this.sharedDataService.PopulateAviClientIds(),
      this.sharedDataService.PopulateAggregationResults(force),
      this.sharedDataService.PopulateIncompleteExtractionClients()
    ]).toPromise();
    await this.CallMapAggregationResultsToTable();
    await this.extractionResultToTableValue();

    this.interval = setInterval(() => {
         this.refreshIncompleteExtractionData();
    }, 300000);
  }

  async refreshIncompleteExtractionData() {
    await this.sharedDataService.PopulateIncompleteExtractionClients(true);
    await this.extractionResultToTableValue();
  }

  async HandleSelect(param) {
    await this.GetRelatedClients(param.selected[0].clientId);

    this.hasTouchedGrid = true;
    if (this.tab_NewOrOthers === "new") {
      this.selectedNew = param.selected;
      this._aggregationDetailComponent.Initialize(this.selectedNew[0].uniqueId);
      this.selectedOther = [];
    } else {
      this.selectedOther = param.selected;
      this._aggregationDetailComponent.Initialize(this.selectedOther[0].uniqueId);
      this.selectedNew = [];
    }
  }

  async OnClientSearchChange(clientId: string) {
    this.selectedNew = [];
    this.selectedOther = [];

    document.querySelectorAll('datatable-body')[0].scrollTop = 1; // fix from bug https://github.com/swimlane/ngx-datatable/issues/1220
    await new Promise((resolve) => { setTimeout(() => resolve(), 100); }); // a render-wait sleep for scroll change (part of bug fix).

    if (!clientId || clientId === "") {
      this.CallMapAggregationResultsToTable();
    } else {
      // filter the new rows.
      this.newRows = [];
      this.otherRows = [];

      let holder = this.sharedDataService.aggregationResults.filter(elem => elem.clientId === clientId && elem.status === AggregationResultStatus.New);
      holder.forEach((elem, idx) => {
        const rowVal = this.AggregationResultToTableValue(elem);
        this.newRows.push(rowVal);
      });
      this.newRows = [...this.newRows];

      // filter the old rows.
      holder = this.sharedDataService.aggregationResults.filter(elem => elem.clientId === clientId && elem.status !== AggregationResultStatus.New);
      holder.forEach((elem, idx) => {
        const rowVal = this.AggregationResultToTableValue(elem);
        this.otherRows.push(rowVal);
      });
      this.otherRows = [...this.otherRows];
    }

  }

  async onSelectedClientChange() {
    let aviId = this.selectedClient ? this.selectedClient.clientParty.mailStop : null;
    await this.OnClientSearchChange(aviId);
  }

  changeSelectionType() {
    if (this.curSelectionType === SelectionType.single) {
      this.curSelectionType = SelectionType.checkbox;
    } else if (this.curSelectionType === SelectionType.checkbox) {
      this.curSelectionType = SelectionType.single;
    }
    this.selectedNew = [];
    this.selectedOther = [];
  }

  async deleteSelectedAggregations() {
    let isDelete = await this._modalService.open(this.content, { size: "lg", ariaLabelledBy: 'modal-basic-title'}).result;
    if (isDelete) {
      this.showSpinner = true;
      try {
        let selected = this.tab_NewOrOthers === 'new' ? this.selectedNew : this.selectedOther;
        await this.removeAggregationsFromUI();
      } catch (ex) {
        this.errorHandlerComponent.error("The delete process failed for some or all clients. Please view full error message for IDs.", {
          fullmessage: ex.error.Data ? ex.error.Data  : ex.error
        });
      } finally {
        this.showSpinner = false;
      }
    }
  }

  async removeAggregationsFromUI() {
    await this.ngOnInit(true);
  }

  deselecteAggregation(aggregation) {
    if (this.tab_NewOrOthers === "new") {
      let idx = this.selectedNew.indexOf(aggregation);
      this.selectedNew.splice(idx, 1);
      this.selectedNew = [ ... this.selectedNew ];
    }
    if (this.tab_NewOrOthers === "other") {
      let idx = this.selectedOther.indexOf(aggregation);
      this.selectedOther.splice(idx, 1);
      this.selectedOther = [ ... this.selectedOther ];
    }
  }

  // #endregion

  // #region Private Methods
  private async CallMapAggregationResultsToTable() {
    // empty the rows.
    this.newRows = [];
    this.otherRows = [];

    this.sharedDataService.aggregationResults.forEach((aggregationResult, idx) => {
      // create the object to pass into one of our tables.
      const rowValue = this.AggregationResultToTableValue(aggregationResult);

      // select the table to apply the aggregation result to.
      if (aggregationResult.status === AggregationResultStatus.New) {
        this.newRows.push(rowValue);
      } else {
        this.otherRows.push(rowValue);
      }
    });

    this.newRows = [...this.newRows];
    this.otherRows = [...this.otherRows];

    this.showSpinner = false;
  }

  private AggregationResultToTableValue(aggregationResult: ClientBillingAggregationResult) {
    // get all ignores for this client.
    let ignores = this.sharedDataService.ignoreProducts.filter(el => el.aviClientId == aggregationResult.clientId);
    // calculate the number of exceptions.
    let exceptionCount: number = 0;

    aggregationResult.billingAgreementExceptions.forEach(elem => {
      let ignore = ignores.find(val => val.productDescription === elem.billingAgreement);
      if (!ignore) {
        exceptionCount += elem.exceptionCount;
      }
    });

    // calculate the number of aggregations.
    let aggregationCount: number = 0;
    aggregationResult.aggregations.forEach(aggregation => {
      aggregationCount += aggregation.value;
    });

    // create the object to pass into one of our tables.
    return {
      clientId: aggregationResult.clientId,
      exceptionCount: exceptionCount,
      aggregationCount: aggregationCount.toFixed(2).replace(/[.,]00$/, ""),
      status: aggregationResult.status,
      uniqueId: aggregationResult.id,
      year: aggregationResult.year,
      month: aggregationResult.month,
      dataLineageId: aggregationResult.dataLineageId
    };
  }

  onDetailDataChange() {
    this.selectedClient = null;
    this.CallMapAggregationResultsToTable();
  }

  onDetailloadingChange(isLoading) {
    this.aggrDetailLoading = isLoading;
  }

  async UpdateAggregateResult(aggregate: ClientBillingAggregationResult) {

    this.aggrDetailLoading = true;
    this.showSpinner = true;

    let actualAggregate = this.sharedDataService.aggregationResults.find(x => x.clientId === aggregate.clientId);
    let oldStatus = actualAggregate.status;

    try {
      actualAggregate.status = aggregate.status;
      let result = await this.aggregationResultService.Update({updatedResult: actualAggregate}).toPromise();
      actualAggregate.dataLineageId = result.deliveryStageDataLineageId;

      this.onDetailDataChange();
      this.showSpinner = false;
      this.aggrDetailLoading = false;
    } catch (e) {
      this.sharedDataService.HandleError("Failed to Update Aggregate Result. Error: " + e);
      actualAggregate.status = oldStatus;

      this.showSpinner = false;
      this.aggrDetailLoading = false;
    }
  }

  private async GetRelatedClients(clientId?: string) {
    if (!this.sharedDataService.relatedClients.some(obj => obj.clientId === clientId))
    {
      try {
        this.showSpinner = true;
        this.sharedDataService.relatedClients = [];
        var childParentRelationships = await this.sfClientRegistryBL.GetClientParentChildRelationshipById({ clientId: clientId}).toPromise();

        // should always be a parent if results are returned
        if ( this.sharedDataService.aggregationResults.some(row => row.clientId === childParentRelationships.parentClientId )) {
          this.sharedDataService.relatedClients.push({ type: "parent", clientId: childParentRelationships.parentClientId });
        }
      } catch (e) {
        this.sharedDataService.HandleError("Failed to retrieve any parent or child clients.  " + e);
        this.showSpinner = false;
      }

      if(null !== childParentRelationships.childClientIds ) {
        childParentRelationships.childClientIds.forEach(child => {
          {
            if (this.sharedDataService.aggregationResults.some(row => row.clientId === child)) {
            this.sharedDataService.relatedClients.push({ type: "sibling", clientId: child });
            }
          }
        });
      }
      this.showSpinner = false;
    }
  }

  async onRelatedClientChange(relatedClientId?: string) {
    var gridRows: any[] = [];
    var aggResults = this.sharedDataService.aggregationResults;

    //  we have the aggregations find the client and determine it's aggregation status set the tab and rows needed to be populated
    var  relClientAgg = aggResults.filter(elem => elem.clientId === relatedClientId)[0];

    if (relClientAgg.status === AggregationResultStatus.New) {
      var newtab = document.getElementById('option1') as HTMLElement;
      newtab.click();

      aggResults.filter(elem => elem.clientId === relatedClientId && elem.status === AggregationResultStatus.New).forEach((elem, idx) => {
        const rowVal = this.AggregationResultToTableValue(elem);
        gridRows.push(rowVal);
      });
    } else {
      var otherTab = document.getElementById('option2') as HTMLElement;
      otherTab.click();

      aggResults.filter(elem => elem.clientId === relatedClientId && elem.status !== AggregationResultStatus.New).forEach((elem, idx) => {
        const rowVal = this.AggregationResultToTableValue(elem);
        gridRows.push(rowVal);
      });
    }

    var newSelectedClient = this.sharedDataService.clientParties.filter(clientParty =>
    {
      return clientParty.clientParty.mailStop === relatedClientId;
    })[0];
    this.selecteDropdownClient = newSelectedClient.clientParty.mailStop;

    let index = this.sharedDataService.clientParties.indexOf(newSelectedClient);

    // opens drop down
    this.mySelect.first.open();
    var opt = this.mySelect.first.dropdownPanel.items[index];
    this.mySelect.first.select(opt);

    // values have already been selected and set. Fire off arbitrary click event using first element
    var ele = this.mySelect.first.dropdownPanel.contentElementRef.nativeElement as HTMLElement;
    ele.click();

    var param = gridRows.filter(function(row) {return row.clientId === relatedClientId; });

    this.HandleSelect( {selected: param } );
  }

  private async extractionResultToTableValue() {
    this.incompleteExtractRows = [];

    this.sharedDataService.allClientstatusEntities
    .filter(item => !item.completedAviUsageDataExtractOn)
    .forEach( item => {
      const rowValue = {
        clientId: item.clientId,
        exceptionCount: "--",
        aggregationCount: "--",
        status: "--",
        uniqueId: item.correlationId,
        year: item.year,
        month: item.month,
        dataLineageId: ""
      };

      this.incompleteExtractRows.push(rowValue);
    });

    this.incompleteExtractRows = [...this.incompleteExtractRows];
  }
  // #endregion
}
